﻿import common from "../common";
// import Page_ from "./components/Page"
// import MessagesManager_ from "./components/MessagesManager";
// import Notifications_ from "./components/Notifications";
// import Pooler_ from "../core/Pooler";
// import Navigation2_ from "./components/Navigation2";

// const Page = require("./components/Page") as Page_;
// const MessagesManager = require("./components/MessagesManager") as MessagesManager_;
// const Notifications = require("./components/Notifications") as Notifications_;
// const Pooler = require("../core/Pooler") as Pooler_;
// const Navigation2 = require("./components/Navigation2") as Navigation2_;

interface IUpaWindow extends Window {
    currentContext: common.IContext;
}

export = ((context: common.IContext) => {
    context.bag = {} as any;
    /** 'key' peut etre 'PascalCase' autant que 'camelCase' */
    context.resources.get = (key: string, defaultCulture?: common.Cultures) => {
        const k = key.charAt(0).toLowerCase() + key.slice(1);
        return !!(context.resources as any)[k]
            ? (context.resources as any)[k][context.culture.name ?? defaultCulture ?? common.Cultures.fr]
            : null;
    };
    context.culture = context.culture || {} as common.ICultureContext;
    context.culture.get = (defaultCulture?: common.Cultures) =>
        context.culture && context.culture.name
            ? common.Cultures[context.culture.name as common.Cultures] ?? (function () { throw "La culture '" + context.culture.name + "' n'existe pas."; })()
            : defaultCulture ?? common.Cultures.fr;
    context.components = {
        items: {},
        add: (webComponent: common.IWebComponent) => {
            //Bug IE11
            //https://stackoverflow.com/questions/25140723/constructor-name-is-undefined-in-internet-explorer
            const t = (webComponent as any).getTypeName();
            if (context.components.items[t])
                context.components.items[t].push(webComponent);
            else
                context.components.items[t] = [webComponent];
            return webComponent;
        },
        /** f: retourner TRUE pour faire un 'break'. */
        doForEarch: (f: (type: string, webComponent: common.IWebComponent) => void | boolean, skipNullEntries?: boolean) => {
            if (!f) throw "L'argument 'f' est NULL.";
            skipNullEntries = skipNullEntries !== false;//default=TRUE
            for (let k in context.components.items || {}) {
                const components = context.components.items[k] as common.IWebComponent[];
                if (components)
                    for (let i = 0; i < components.length; i++) {
                        const c = components[i];
                        if ((c || !skipNullEntries) && f(k, c))
                            return;
                    }
            }
        },
        getByType: (type: string, skipNullEntries?: boolean) => {
            skipNullEntries = skipNullEntries !== false;//default=TRUE
            if (!type) return [];
            const all = context.components.items[type] ?? [];
            const res = [];
            for (let i = 0; i < all.length; i++) {
                const c = all[i];
                if (c || !skipNullEntries)
                    res.push(c);
            }

            return res;
        },
        getPage: () => {
            return context.components.items["Page"][0];
        },
        getMessagesManager: () => {
            return context.components.getPage().getMessagesManager();
        },
        getNotifications: () => {
            return context.components.getPage().getNotifications();
        },
        getMainNavigation: () => {
            return context.components.getPage().getMainNavigation();
        },
        getPooler: () => {
            return context.components.getPage().getPooler();
        }
    } as common.IComponentsContext;

    return context as common.IContext;
})(((window as IUpaWindow & typeof globalThis)?.currentContext ?? {}) as common.IContext);